import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MyOrganizationService } from 'libs/data/src/lib/services/my-organization/my-organization.service';
import { catchError, finalize, firstValueFrom, of } from 'rxjs';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { trialActiveStr } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss'],
})
export class CreateUserComponent implements OnInit {
  organizationId: string | null = null;
  newUserData: any = null;
  isLoading = true;
  hasError = false;
  errorMessage = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private myOrganizationService: MyOrganizationService,
    private sharedService: SharedService
  ) {}

  ngOnInit() {
    // Get organization ID from route params (not query params)
    const encodedOrgId = this.route.snapshot.paramMap.get('id');

    if (!encodedOrgId) {
      this.hasError = true;
      this.errorMessage = 'Invalid registration link. Organization ID is missing.';
      this.isLoading = false;
      this.toastr.error('Invalid registration link');
      return;
    }
    try {
      this.organizationId = atob(encodedOrgId);
    } catch (error) {
      this.hasError = true;
      this.errorMessage = 'Invalid registration link. Unable to decode organization ID.';
      this.isLoading = false;
      this.toastr.error('Invalid registration link');
      return;
    }

    // Load the data for the form
    this.loadFormData();
  }

  async loadFormData() {
    try {
      this.isLoading = true;
      const response: any = {};
      const countryList = await firstValueFrom(this.sharedService.getCountry(true));
      response['country'] = countryList?.data;
      if (response) {
        this.newUserData = {
          ...response,
          // Set defaults for create user mode
          isCreateUserMode: true,
          hideOrganizationField: true,
          hideRoleField: true,
          hideTriggerAutomation: true,
        };
      }

      this.isLoading = false;
    } catch (error) {
      this.hasError = true;
      this.errorMessage = 'Failed to load registration form. Please try again later.';
      this.isLoading = false;
      this.toastr.error('Failed to load registration form');
    }
  }

  onSaveUser(event: any) {
    const userPayload = {
      ...event.payload,
      encOrganizationId: this.organizationId,
      email: event.payload.userName,
    };

    // Call the add user service
    this.myOrganizationService
      .addUserViaLink(userPayload)
      .pipe(
        catchError((error: any) => {
          this.toastr.error('Failed to create account. Please try again.');
          return of(null);
        }),
        finalize(() => {})
      )
      .subscribe(res => {
        if (res) {
          if (!res.messageType) {
            sessionStorage.setItem('registerEmail', userPayload.email);
            this.router.navigate([`/${trialActiveStr}`], {
              queryParams: { fromShared: true },
            });
          } else {
            this.toastr.error(res.message || 'Failed to create account');
          }
        }
      });
  }

  onCancel() {
    this.router.navigate(['/login']);
  }
}
